import { useState } from "react";

import HintModal from "./hint-modal";

const DefaultHeader = () => {
  // const heading = "FIRM SETTINGS TITLE WITH CENTERED TEXT";
  const points = [
    "Firm settings panel instruction point one",
    "Firm settings panel instruction point two",
    "Firm settings panel instruction point three",
  ];

  const [showHints, setShowHints] = useState(false);

  const handleHintToggle = () => {
    setShowHints(!showHints);
  };

  return (
    <>
      <div className="tab-pane fade firm-settings-user-perms-fs active show">
        <div
          className="d-flex justify-content-end m-b-5"
          onClick={() => {
            handleHintToggle();
          }}
        >
          <i className="ic ic-19 ic-help-2 cursor-pointer" />
        </div>
      </div>
      {showHints && <HintModal show={showHints} handleClose={handleHintToggle} points={points} />}
    </>
  );
};

export default DefaultHeader;
